import { SortOption } from 'src/types';

export const getSelectedSortOption = (sortingOptions: SortOption[]) =>
  sortingOptions.find((option) => option.active) || null;
